import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { eventSelector } from '../redux/selectors'
import { toArray } from '../common/util';
import { fetchActiveEvents } from "../redux/actions";

class EventsActive extends Component {
    componentDidMount() {
        this.props.getActiveEvents(this.props.chapter, this.props.section.slug)
    }

    render() {
        if (toArray(this.props.events.data).filter((event) => event.stopped === null).length > 0) {
            return (
                <div>
                    {toArray(this.props.events.data)
                        .filter((event) => event.stopped === null)
                        .filter((event) => event.section === this.props.section.id)
                        .sort((a, b) => new Date(a.created) - new Date(b.created))
                        .map((event) => (
                            <Link key={event.id} to={"/officer/events/" + event.slug}><div>{event.title}</div></Link>
                        ))}
                </div>
            )
        } else {
            return (<div>No Active Events</div>)
        }
    }
}

const mapStateToProps = (state) => ({
    events: eventSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    getActiveEvents: (chapter, section) => dispatch(fetchActiveEvents(chapter, section)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EventsActive);


// WEBPACK FOOTER //
// ./src/Officer/EventsActive.js